// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOrganizationLogoDto
 */
export interface IOrganizationLogoDto {
    /**
     * 
     * @type {string}
     * @memberof IOrganizationLogoDto
     */
    large_logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationLogoDto
     */
    minimized_logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationLogoDto
     */
    dark_large_logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationLogoDto
     */
    dark_minimized_logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationLogoDto
     */
    favicon_url?: string;
}

/**
 * Check if a given object implements the IOrganizationLogoDto interface.
 */
export function instanceOfIOrganizationLogoDto(value: object): value is IOrganizationLogoDto {
    return true;
}

export function IOrganizationLogoDtoFromJSON(json: any): IOrganizationLogoDto {
    return IOrganizationLogoDtoFromJSONTyped(json, false);
}

export function IOrganizationLogoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationLogoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'large_logo_url': json['large_logo_url'] == null ? undefined : json['large_logo_url'],
        'minimized_logo_url': json['minimized_logo_url'] == null ? undefined : json['minimized_logo_url'],
        'dark_large_logo_url': json['dark_large_logo_url'] == null ? undefined : json['dark_large_logo_url'],
        'dark_minimized_logo_url': json['dark_minimized_logo_url'] == null ? undefined : json['dark_minimized_logo_url'],
        'favicon_url': json['favicon_url'] == null ? undefined : json['favicon_url'],
    };
}

export function IOrganizationLogoDtoToJSON(json: any): IOrganizationLogoDto {
    return IOrganizationLogoDtoToJSONTyped(json, false);
}

export function IOrganizationLogoDtoToJSONTyped(value?: IOrganizationLogoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'large_logo_url': value['large_logo_url'],
        'minimized_logo_url': value['minimized_logo_url'],
        'dark_large_logo_url': value['dark_large_logo_url'],
        'dark_minimized_logo_url': value['dark_minimized_logo_url'],
        'favicon_url': value['favicon_url'],
    };
}

